import { ApiError, fetchWithAuth } from "@entities/user-tokens";
import type { SettingsPayload } from "@entities/generation-setting";

import type { GenerationTask, InputSelection } from "../GenerationTask";

/**
 * 生成タスクを更新する（`?run=true` で preparing → waiting ＝生成開始）。
 *
 * アドインが使う主目的は **再生成の開始**である。コンソールの生成開始モーダルが使うのと同じ口
 * （[[2026-08-12 設計ノート アドインのAWS連携追随]]）。
 *
 * **`prompts` は表示のための写しである。** サーバーは受け取った payload を縮約して保存するので
 * （`reduce_to_overlay`）、残るのは担当ごとの skip と表示名、それに名前の対応表だけで、指示の
 * 本文・対象・スライドと要素の設定は落ちる。手元で直した本文を実行へ届けるのは
 * `putTaskOverrides`（上書き）であって、ここではない。
 *
 * 本文に含めたフィールドだけが更新対象になる（サーバーはキーの有無で判定する）。
 */
export async function updateTask(
    projectId: string,
    taskId: string,
    patch: {
        label?: string;
        prompts?: SettingsPayload;
        inputSelection?: InputSelection;
    } = {},
    options: { run?: boolean } = {}
): Promise<GenerationTask> {
    const base = `/generation-tasks/${encodeURIComponent(taskId)}`;
    const url = options.run === undefined ? base : `${base}?run=${options.run}`;
    const res = await fetchWithAuth(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ projectId, ...patch }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "生成タスクの更新に失敗しました");
    const body = (await res.json()) as { task: GenerationTask };
    return body.task;
}
